export default "__VITE_ASSET__A0HT8Kea__"